import { en } from "./en";
import { sv } from "./sv";
import { no } from "./no";
import { fi } from "./fi";
import { da } from "./da";

export type SupportedLanguage = "en" | "sv" | "no" | "fi" | "da";

export interface LanguageMeta {
  code: SupportedLanguage;
  name: string;
  nativeName: string;
  flag: string;
  country: string;
}

export const LANGUAGES: Record<SupportedLanguage, LanguageMeta> = {
  en: {
    code: "en",
    name: "English",
    nativeName: "English",
    flag: "🇬🇧",
    country: "International",
  },
  sv: {
    code: "sv",
    name: "Swedish",
    nativeName: "Svenska",
    flag: "🇸🇪",
    country: "Sweden",
  },
  no: {
    code: "no",
    name: "Norwegian",
    nativeName: "Norsk",
    flag: "🇳🇴",
    country: "Norway",
  },
  fi: {
    code: "fi",
    name: "Finnish",
    nativeName: "Suomi",
    flag: "🇫🇮",
    country: "Finland",
  },
  da: {
    code: "da",
    name: "Danish",
    nativeName: "Dansk",
    flag: "🇩🇰",
    country: "Denmark",
  },
};

export const dictionaries = {
  en,
  sv,
  no,
  fi,
  da,
};

export { en, sv, no, fi, da };
export type { TranslationSchema } from "./en";
